const facebookPixelAgent = {
  /**
   * 페이스북 픽셀 이벤트(표준 또는 커스텀)를 추적합니다.
   * @see https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking/#standard-events
   */
  // eslint-disable-next-line @typescript-eslint/ban-types
  trackEvent(eventType: 'track' | 'trackCustom', eventName: string, eventParameter?: object) {
    window.fbq(eventType, eventName, eventParameter);
  },
};

export default facebookPixelAgent;
